
<script setup lang="ts">
    
</script>

<template>
    <!-- 作品审核状态标签 -->
    <div class="flex flex-col rounded-md bg-[#fae7c5] lg:scale-100 md:scale-75">
        <span class="text-[#9b2f23] text-xs" style="padding: 2px 8px;font-weight:700;line-height:20px;">
            优秀作品
        </span>
    </div>
</template>


<style scoped>

</style>